import type { ButtonVariants } from "@qws-org/ui-kit";

export const BUTTON_VARIANTS = [
  "default",
  "transparent",
  "accent",
  "secondary",
  "tertiary",
  "primary",
] as const satisfies ReadonlyArray<ButtonVariants>;

/**
 * Runtime whitelist + type guard for ButtonVariants.
 * Protects UI-kit Button from invalid variant values coming from CMS.
 */

export function isButtonVariant(value: unknown): value is ButtonVariants {
  return (
    typeof value === "string" &&
    BUTTON_VARIANTS.includes(value as ButtonVariants)
  );
}
